import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import "animate.css/animate.css";
import './styles/TagMemoFields.css';

const TagMemoFields = (props) => {
  const [textValue, setTextValue] = useState("");
  const [error, setError] = useState(false);
  const tipText = props.prompt ? props.prompt : '';
  const isAlwaysOn = props.isAlwaysOn || false;
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;

  useEffect(() => {
    setTextValue(props.value || "");
  }, [props.value]);

  // Enhanced useEffect: Handle both Case 4 and Case 2 validation
  useEffect(() => {
    let newError = false;
    
    if (validationCase === 'case_4') {
      // Case 4: Tag is required (alwaysOn), Variable Value is required
      if (props.required && isAlwaysOn) {
        if (!textValue || textValue.trim() === "") {
          newError = true;
        }
      }
    } else if (validationCase === 'case_2') {
      // Case 2: Tag is not required, but if tag is selected then the Variable is required
      if (props.required && isTagChecked) {
        if (!textValue || textValue.trim() === "") {
          newError = true;
        }
      }
    }
    
    setError(newError);
  }, [textValue, props.required, isAlwaysOn, validationCase, isTagChecked]);

  const handleChange = (event) => {
    // Allow letters, digits, common punctuation, AND \n / \r so users can
    // press Enter to insert line breaks in a multiline memo field.
    const sanitized = event.target.value.replace(/[^a-zA-Z0-9-?+$%@&<>|#?,.!<>()/*'\\;: \n\r]/g, "");
    const newValue = sanitized;
    if (props.maxLength === undefined || newValue.length <= props.maxLength) {
      setTextValue(newValue);

      // Determine validity based on the new value and validation case
      let isValid = true;
      
      if (validationCase === 'case_4' && props.required) {
        // Case 4: Always required if alwaysOn tag
        if (!newValue || newValue.trim() === "") {
          isValid = false;
        }
      } else if (validationCase === 'case_2' && props.required && isTagChecked) {
        // Case 2: Required only if tag is checked
        if (!newValue || newValue.trim() === "") {
          isValid = false;
        }
      }

      props.onChange({
        name: props.param,
        value: newValue,
        isValid: isValid
      });
    }
  };

  // Determine helper text based on validation case
  const getHelperText = () => {
    if (error) {
      if (validationCase === 'case_4') {
        return "This field is required";
      } else if (validationCase === 'case_2') {
        return "This field is required if active";
      }
    }
    return "";
  };

  return (
    <Grid container className="tag-memo-fields-container">
      <Grid item xs={12} sm={12}>
        <Tooltip title={tipText} placement="top" arrow>
          <TextField
            multiline
            minRows={props.minRows || 3}
            fullWidth
            variant="outlined"
            label={props.label}
            name={props.param}
            value={textValue}
            onChange={handleChange}
            error={error}
            helperText={getHelperText()}
            className="tag-memo-fields-input"
            inputProps={{
              maxLength: props.maxLength === undefined ? 200 : props.maxLength,
              tabIndex: props.tabIndex || 0
            }}
            InputProps={{ endAdornment: null }}
          />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default TagMemoFields;